export var isUnsupported = function () {
    var ua = navigator.userAgent;
    return ua.indexOf('MSIE') > 0 || ua.indexOf('Trident') > 0;
};
